import React, { useState } from 'react';
import { extractTextFromImage } from '../services/ocr';

const TopicInput = ({ onSubmit, loading, placeholder = "Enter a topic or upload an image..." }) => {
  const [input, setInput] = useState('');
  const [imageLoading, setImageLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim() && !loading) {
      onSubmit(input.trim());
      setInput('');
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setImageLoading(true);
    try {
      const text = await extractTextFromImage(file);
      setInput(text);
      setImageLoading(false);
    } catch (error) {
      console.error('OCR error:', error);
      setImageLoading(false);
      alert('Failed to extract text from image. Please try again.');
    }
  };

  return (
    <div className="card">
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Text Input */}
        <div>
          <label className="block text-sm font-medium mb-2">What would you like to learn?</label>
          <textarea
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder={placeholder}
            rows={4}
            className="textarea-field"
            disabled={loading || imageLoading}
          />
        </div>

        {/* Image Upload */}
        <div className="flex items-center gap-4">
          <label className="flex-1">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              className="hidden"
              disabled={loading || imageLoading}
            />
            <div className="btn-outline cursor-pointer text-center">
              {imageLoading ? (
                <span className="flex items-center justify-center gap-2">
                  <div className="spinner w-5 h-5"></div>
                  Extracting text...
                </span>
              ) : (
                <span className="flex items-center justify-center gap-2">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  Upload Image
                </span>
              )}
            </div>
          </label>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={!input.trim() || loading || imageLoading}
            className="btn-primary flex-1"
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <div className="spinner w-5 h-5"></div>
                Processing...
              </span>
            ) : (
              'Start Learning 🚀'
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TopicInput;